/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconTransferVertical = createReactComponent("outline", "transfer-vertical", "IconTransferVertical", [["path", { "d": "M10 4v16l-6 -5.5", "key": "svg-0" }], ["path", { "d": "M14 20v-16l6 5.5", "key": "svg-1" }]]);

export { IconTransferVertical as default };
//# sourceMappingURL=IconTransferVertical.mjs.map
